import { render, staticRenderFns } from "./UserDetailsAdministrationGroupMembershipRights.vue?vue&type=template&id=0b45a114&scoped=true&"
import script from "./UserDetailsAdministrationGroupMembershipRights.vue?vue&type=script&lang=js&"
export * from "./UserDetailsAdministrationGroupMembershipRights.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailsAdministrationGroupMembershipRights.vue?vue&type=style&index=0&id=0b45a114&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b45a114",
  null
  
)

export default component.exports